import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import { translate } from 'react-switch-lang';
import {
  Grid,
  Card,
  CardContent,
  CardHeader,
  CardActionArea,
  Typography,
  FormControl,
  FormLabel,
  FormHelperText,
  TextField,
  Button,
  OutlinedInput,
  IconButton,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogActions,
  DialogContent,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import AssetTable from '../../_InventoryFlagments/assetchecktable';
import StdDatatable from '../../_InventoryFlagments/StdDatatable';
import { assetService } from '../../../../_services/asset.service';
import { clearItem } from '../../_InventoryFlagments/redux/actions/assetsearch.action';
import { addItem } from '../redux/actions/assetcheck.action';
import { AssetCheckServices as service } from '../services/assetcheck.service';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(0),
    margin: theme.spacing(0),
  },
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
  },
  card: {
    // height: 100,
  },
  cardHeader: {
    backgroundColor: theme.palette.background.default,
  },
  btnSave: {
    color: theme.palette.primary.main,
    marginLeft: theme.spacing(0),
    marginRight: theme.spacing(1),
  },
  btnBack: {
    color: theme.palette.error.main,
    marginLeft: theme.spacing(0),
    marginRight: theme.spacing(1),
  },
}));

const AssetCheckDetail = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t, history, register, setValue, ...rest } = props;

  //redux
  const storageAsset = useSelector((state) => state.assetSearch);
  const storageAssetCheck = useSelector((state) => state.assetCheck);

  //state
  const initValue = [
    {
      assetCode: null,
      assetDescription: null,
      serial: null,
      isMatching: null,
      quanitity: null,
      currentOwner: null,
      remark2: null,
    },
  ];
  const [values, setValues] = useState([]);
  const [item, setItem] = useState(initValue);
  const [open, setOpen] = React.useState(false);
  const [assetCheckOwner, setAssetCheckOwner] = useState('');
  const [assetCheckOnwerType, setAssetCheckOnwerType] = useState('');
  const searchInput = useRef(null);
  const assetCodeInputFocus = useRef(null);

  let loading = false;

  //useEffects
  useEffect(() => {
    //  console.log(storageAssetCheck);
    setAssetCheckOwner(
      Object.keys(storageAssetCheck).map((key) => {
        return storageAssetCheck[key].value;
      }),
    );
  }, [storageAssetCheck]);

  //getUpdate Data
  useEffect(() => {
    //console.log(props.code);
    if (!!props.code) {
      loading = true;

      if (loading) {
        service
          .getItem(props.code)
          .then((res) => {
            loading = false;
            console.log(res.data.result);
            const dtl = res.data.result.assetCheckDetails;
            setAssetCheckOwner(res.data.result.owner);
            setValues(...values, dtl);
            dispatch(addItem(dtl));
          })
          .catch((error) => {
            loading = false;
            window.alert('error', error);
          });
      }
    }
  }, []);

  useEffect(() => {
    if (storageAsset.closing) {
      service
        .AssetCheckOnwerVerify(assetCheckOwner[0], storageAsset.Code)
        .then((res) => {
          setItem({
            assetCode: storageAsset.Code,
            assetDescription: storageAsset.Description,
            serial: storageAsset.Serial,
            quanitity: 1,
            isMatching: res.isMapping,
            currentOwner: res.currentOwner ? res.currentOwner : '',
            remark2: res.remark,
          });
        });
      setOpen(false);
    }
  }, [storageAsset]);

  //Events
  const handleChange = (event) => {
    // console.log(event.target.name, ' ', event.target.value);
    setItem({
      ...item,
      [event.target.name]: event.target.value,
    });
  };

  const handleOnKeyDown = (event) => {
    assetService.getAssetItemBySerial(event.target.value).then((res) => {
      // console.log(res.data.results[0]);
      try {
        setItem({
          ...item,
          assetCode: res.data.results[0].Code,
          assetDescription: res.data.results[0].Description,
          serial: res.data.results[0].Serial,
          quanitity: '1',
          remarks: '',
        });
        searchInput.current.focus();
      } catch (error) {
        window.alert('Not Found Serial. Please find again');
        setItem(initValue);
        assetCodeInputFocus.current.focus();
      }
    });
  };

  const handleClickOpenPopup = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmitItemAsync = async () => {
    if (item.assetCode != null) {
      setValues([item]);
      setItem(initValue);
      dispatch(addItem);
      assetCodeInputFocus.current.focus();
    } else {
      window.alert('Please find asset code first');
      assetCodeInputFocus.current.focus();
    }
  };

  return (
    <>
      <Card component="div" square>
        <CardHeader
          className={classes.cardHeader}
          title={
            <>
              <Grid container direction="row">
                <Grid item xs={12} sm={8}>
                  <Typography variant="h6">Items</Typography>
                </Grid>
                <Grid item style={{ textAlign: 'end' }} xs={12} sm={4}></Grid>
              </Grid>
            </>
          }
        ></CardHeader>
        <CardContent>
          <Grid justify="center" container direction="row" spacing={1}>
            {!props.readOnly && (
              <>
                <Grid item xs={12} md={3}>
                  <FormControl margin="dense" required fullWidth size="small">
                    <FormLabel component="legend">Asset Code</FormLabel>
                    <OutlinedInput
                      name="assetCode"
                      type="text"
                      // inputRef={register()}
                      inputRef={assetCodeInputFocus}
                      value={[item.assetCode]}
                      onChange={handleChange}
                      onKeyDown={(e) => {
                        if (e.key === 'Tab') {
                          //console.log(e.target.value);
                          handleOnKeyDown(e);
                          // write your functionality here
                        }
                      }}
                      // readOnly
                      // disabled={props.readOnly}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            disabled={props.readOnly}
                            aria-label="search"
                            size="small"
                            onClick={() => {
                              if (assetCheckOwner == '') {
                                window.alert('Please select Onwer fisrt');
                              } else {
                                handleClickOpenPopup();
                              }
                            }}
                            edge="end"
                          >
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      }
                      labelWidth={0}
                    />
                    <FormHelperText>
                      {props.errors.assetCode?.type === 'required' &&
                        'Your input is required'}
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl margin="dense" fullWidth size="small">
                    <FormLabel component="legend">assetDescription</FormLabel>
                    <TextField
                      name="assetDescription"
                      size="small"
                      variant="outlined"
                      value={[item.assetDescription]}
                      //inputRef={register()}
                      onChange={handleChange}
                      disabled
                    />
                    <FormHelperText></FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={1}>
                  <FormControl margin="dense" fullWidth size="small">
                    <FormLabel component="legend">IsMatching</FormLabel>
                    <TextField
                      name="isMatching"
                      size="small"
                      variant="outlined"
                      value={[item.isMatching]}
                      //inputRef={register()}
                      onChange={handleChange}
                      disabled
                    />
                    <FormHelperText></FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl margin="dense" fullWidth size="small">
                    <FormLabel component="legend">Current Owner</FormLabel>
                    <TextField
                      size="small"
                      variant="outlined"
                      name="currentOwner"
                      value={[item.currentOwner]}
                      // inputRef={register()}
                      onChange={handleChange}
                      disabled
                    />
                    <FormHelperText>
                      {props.errors.currentOwner?.type === 'required' &&
                        'Your input is required'}
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl margin="dense" fullWidth size="small">
                    <FormLabel component="legend">Asset Serial</FormLabel>
                    <TextField
                      size="small"
                      variant="outlined"
                      name="serial"
                      value={[item.serial]}
                      // inputRef={register()}
                      onChange={handleChange}
                      disabled
                    />
                    <FormHelperText>
                      {props.errors.serial?.type === 'required' &&
                        'Your input is required'}
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={2}>
                  <FormControl margin="dense" fullWidth size="small">
                    <FormLabel component="legend">quanitity</FormLabel>
                    <TextField
                      size="small"
                      variant="outlined"
                      name="quanitity"
                      type="number"
                      value={[item.quanitity]}
                      // inputRef={register()}
                      onChange={handleChange}
                      disabled
                    />
                    <FormHelperText>
                      {props.errors.quanitity?.type === 'required' &&
                        'Your input is required'}
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl margin="dense" fullWidth size="small">
                    <FormLabel component="legend">Remark</FormLabel>
                    <TextField
                      size="small"
                      variant="outlined"
                      name="remark2"
                      value={[item.remark2]}
                      inputRef={register()}
                      onChange={handleChange}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={2}>
                  <FormControl margin="dense" fullWidth size="small">
                    <FormLabel component="legend">Action</FormLabel>
                    <Button
                      fullWidth
                      ref={searchInput}
                      variant="outlined"
                      color="primary"
                      onClick={(e) => {
                        onSubmitItemAsync(e);
                        return e;
                      }}
                    >
                      Add
                    </Button>
                  </FormControl>
                </Grid>
              </>
            )}

            <Grid item xs={12} md={12}>
              <AssetTable getItems={values} readOnly={props.readOnly} />
            </Grid>
          </Grid>
        </CardContent>
        <CardActionArea>Action</CardActionArea>
      </Card>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth={true}
        maxWidth="lg"
      >
        <DialogTitle id="form-dialog-title">Asset Master Search</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please find Asset Master as below:
          </DialogContentText>
          <div>
            <StdDatatable />
          </div>
        </DialogContent>

        <DialogActions>
          <Button color="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleClose}>
            Search
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AssetCheckDetail;
